import { render, staticRenderFns } from "./ConceptProviderForm.vue?vue&type=template&id=3d7c2ba4&"
import script from "./ConceptProviderForm.vue?vue&type=script&lang=js&"
export * from "./ConceptProviderForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports